import { authButton } from './authenticator'

export const installButton = {
  ...authButton,
  cursor: 'pointer',
}

export const installButtonWrapper = {
  paddingTop: '20px',
  paddingBottom: '30px',
}

export const buttonText = {
  padding: '15px',
  textAlign: 'center',
}
